import { render } from "./VersionComponent.vue?vue&type=template&id=297a6036&ts=true"
import script from "./VersionComponent.vue?vue&type=script&lang=ts"
export * from "./VersionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__